import { useEffect, useEffectEvent, useState } from "react";

export enum TeamDeletionWizardSteps {
  DELETE_TEAM_CONFIRMATION = "DELETE_TEAM_CONFIRMATION",
  USERS = "USERS",
  TASKS = "TASKS",
  COMPLETION = "COMPLETION",
}

type TeamDeletionWizardAPI = {
  currentStep: TeamDeletionWizardSteps | undefined;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
};

export type OnWizardStep = (opt: {
  step: TeamDeletionWizardSteps | undefined;
  wizardAPI: TeamDeletionWizardAPI;
}) => Promise<void>;

type UseTeamDeletionWizardArgs = {
  steps: TeamDeletionWizardSteps[];
  onWizardStep: OnWizardStep;
};

export const useTeamDeletionWizard = ({
  steps,
  onWizardStep,
}: UseTeamDeletionWizardArgs) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const currentStep = steps[currentStepIndex];

  const goToNextStep = () => {
    setCurrentStepIndex((prevCurrentStepIndex) =>
      Math.min(prevCurrentStepIndex + 1, steps.length - 1)
    );
  };

  const goToPreviousStep = () => {
    setCurrentStepIndex((prevCurrentStepIndex) =>
      Math.max(prevCurrentStepIndex - 1, 0)
    );
  };

  const wizardAPI: TeamDeletionWizardAPI = {
    currentStep: steps[currentStepIndex],
    goToNextStep,
    goToPreviousStep,
  };

  const onWizardStepListener = useEffectEvent(
    (step: TeamDeletionWizardSteps | undefined) =>
      onWizardStep({ step, wizardAPI })
  );
  useEffect(() => {
    onWizardStepListener(currentStep);
  }, [currentStep]);

  return wizardAPI;
};
